let count = 0;

export const objectIndex = (obj) => {
  if (typeof obj.__uniqueid === 'undefined') {
    Object.defineProperty(obj, '__uniqueid', { value: ++count, enumerable: false, writable: false });
  }

  return `obj@${obj.__uniqueid}`;
};
